import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { RedBookResponse } from '../../../../types/redbook';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import { getRedBookYearGroups } from '../../requests/getRedBookYearGroups';

export const useRedBookYearGroups = (
  params?: RequestConfig['params'],
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();
  const { data, ...rest } = useQuery<
    NonPaginatedResponse<RedBookResponse> | undefined
  >({
    queryKey: [PLUGIN_BASE_PATH, 'red-book-year-groups', params],
    queryFn: () => getRedBookYearGroups(constructGet, params),
    ...options,
  });
  return { ...unwrapNonPaginatedResponseDataAs(data, 'redBookData'), ...rest };
};
